<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-column">
        <div class="content-images">
          <img class="logo-footer" src="/assets/icons/logo-globo.png" />
          <div class="footer-icons">
            <img src="/assets/icons/linkedin.png" />
          </div>
        </div>
      </div>
      <div class="footer-column">
        <ul>
          <li><a href="https://somos.globo.com/" target="_blank">Somos Globo</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <ul>
          <li><a href="https://guiademarcas.globo/" target="_blank">Guia de Marcas</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <ul>
          <li><a href="https://monitordemarcas.g.globo/" target="_blank">Monitor de marcas</a></li>
        </ul>
      </div>
      <div class="footer-column">
        <ul>
          <li><a href="#">política de privacidade</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-end">
      <span>© Copyright {{ currentYear }} Globo Comunicação e Participações S.A.</span>
    </div>
  </footer>
</template>

<script lang="ts">
export default {
  name: 'FooterComponent',
  computed: {
    currentYear(): number {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss">
.footer {
  position: relative;
  background-color: rgba(255, 255, 255, 1);
  padding: 32px 0 20px;
}

.content-images {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer-icons {
  display: flex;
  align-items: center;
  margin-top: 34px;

  img {
    display: block;
  }
}

.logo-footer {
  display: block;
  width: 130px;
  height: auto;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 1032px;
  padding: 32px 0 0;
  margin: 0 auto;
  gap: 57px;
}

.footer-column {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex: 0 0 94px;
  padding: 0;
}

.footer-column:first-child {
  justify-content: flex-start;
  flex: 1;
}

.footer-column h3 {
  margin-bottom: 10px;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin-top: 08px;
}

.footer-column ul li {
  margin-bottom: 1rem;
}

.footer-column ul li a {
  text-decoration: none;
  color: #707A8F;
  font-family: InterVariableLight;
  font-weight: 600;
  font-size: 15px;
  white-space: nowrap;
}

.footer-column ul li a:hover {
  text-decoration: none;
}

.footer-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  max-width: 1032px;
  padding: 56px 0 0;
  margin: 0 auto;

  span {
    font-size: 12px;
    color: rgba(112, 122, 143, 1);
  }

  p {
    font-size: 15px;
  }
}

@media (max-width: 1000px) {
  .footer-container {
    flex-wrap: wrap;
    row-gap: 18px;
  }

  .footer-column {
    flex: 1 1 180px;
  }

  .footer-column:first-child {
    flex-basis: 100%;
  }
}

@media (max-width: 640px) {
  .footer {
    padding-top: 24px;
  }

  .footer-container,
  .footer-end {
    width: calc(100% - 32px);
    max-width: 1032px;
  }

  .footer-container {
    padding-top: 8px;
  }

  .footer-icons {
    margin-top: 20px;
  }

  .footer-end {
    justify-content: flex-start;
    padding-top: 28px;
  }

  .footer-end span {
    line-height: 1.4;
  }
}
</style>
